// Dark geometric SVG data URI to layer under the vault section
const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='800' height='600' viewBox='0 0 800 600'>
  <defs>
    <pattern id='grid' width='40' height='40' patternUnits='userSpaceOnUse'>
      <path d='M 40 0 L 0 0 0 40' fill='none' stroke='rgba(245,158,11,0.05)' stroke-width='1'/>
    </pattern>
    <radialGradient id='glow' cx='30%' cy='40%' r='60%'>
      <stop offset='0%' stop-color='rgba(245,158,11,0.12)'/>
      <stop offset='100%' stop-color='transparent'/>
    </radialGradient>
  </defs>
  <rect width='100%' height='100%' fill='#0A0A0A'/>
  <rect width='100%' height='100%' fill='url(#grid)'/>
  <rect width='100%' height='100%' fill='url(#glow)'/>
  <g stroke='rgba(255,255,255,0.06)' fill='none' stroke-width='1'>
    <circle cx='240' cy='240' r='120'/>
    <circle cx='240' cy='240' r='180'/>
    <circle cx='240' cy='240' r='240'/>
    <path d='M 0 300 L 800 300' stroke-dasharray='2 8'/>
    <path d='M 400 0 L 400 600' stroke-dasharray='2 8'/>
  </g>
</svg>`;

const encoded = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
export default encoded;
